import React from "react";
import { useDatePickerContext } from "./DatePickerContext";
import { Dayjs } from "dayjs";
import dayjs from "@dayjs";
import { COLORS } from "@/app/common/consts/colors";
import { Calendar } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";

interface DateInputProps {
  onClick: () => void;
  isCustomClass?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({ onClick, isCustomClass }) => {
  const { selectedDate, error } = useDatePickerContext();
  const t = useTranslations();
  const locale = useLocale();

  const formatDisplayDate = (date: Dayjs | null, locale: string): string => {
    if (!date) {
      return "";
    }

    return dayjs(date)
      .locale(locale)
      .format(locale === "en" ? "ddd, MMM D" : "YYYY-MM-DD");
  };

  return (
    <button
      type="button"
      className={`custom-date-input desktop-calendar-input-container flex w-full flex-row items-center justify-start gap-2 rounded-full border-[1px] px-6 md:w-full 2xl:border-2 h-12 ${
        error
          ? "border-red-500"
          : "border-sleap-gray-400  dark:border-input dark:hover:border-white"
      } ${isCustomClass ? "bg-transparent text-lightwhite hover:border-sleap-gray-50" : "bg-lightwhite text-sleap-gray-950 dark:bg-sleap-gray-950 dark:text-lightwhite hover:border-sleap-gray-600"}
      `}
      onClick={onClick}
      aria-label="Select check-in and check-out dates"
      aria-invalid={error ? "true" : "false"}
    >
      <div className="relative h-6 w-6 overflow-hidden">
        <span className="hidden h-6 w-6 dark:block">
          <Calendar className="w-5 h-5" color={COLORS["white"]} />
        </span>
        <span className="block h-6 w-6 dark:hiddenk:block">
          <Calendar
            className="w-5 h-5"
            color={COLORS[isCustomClass ? "white" : "black"]}
          />
        </span>
      </div>
      <div
        className="flex-1 text-base font-medium text-left overflow-auto flex-nowrap text-nowrap"
        style={{ lineHeight: "24px" }}
      >
        {selectedDate?.[0]
          ? formatDisplayDate(selectedDate[0], locale)
          : t("Other.checkIn")}
        <span className="mx-1"> - </span>
        {selectedDate?.[1]
          ? formatDisplayDate(selectedDate[1], locale)
          : t("Other.checkOut")}
      </div>
    </button>
  );
};

export default DateInput;
